<script>
  import * as solo_shows_list from "../data/solo_shows_data";
  import { onMount } from "svelte";
  import ListItem from "./ListItem.svelte";

  let collapsible_elem;
  const solo_shows = solo_shows_list.solo_shows;

  onMount(() => {
    M.Collapsible.init(collapsible_elem);
  });
</script>

<div class="divider"></div>

<div id="showslist" class="section">
  <div class="container">
    <div class="row">
      <h3 class="blue-grey-text text-lighten-2">List of exhibitions</h3>
      <ul class="collapsible" bind:this={collapsible_elem}>
        <li class="">
          <div id="solo-shows-list" class="collapsible-header">
            <i class="material-icons right"
              ><img
                src="/media/icons/material-icons/outline_account_circle_black_24dp.png"
                alt="outline account circle icon - LFCamacho"
              /></i
            >SOLO SHOWS:
          </div>
          <div class="collapsible-body">
            <ul class="list">
              {#each solo_shows as show, idx}
                <ListItem {show} />
              {/each}
            </ul>
          </div>
        </li>

        <li class="">
          <div id="group-shows-list" class="collapsible-header">
            <i class="material-icons right"
              ><img
                src="/media/icons/material-icons/outline_groups_black_24dp.png"
                alt="outline groups icon - LFCamacho"
              /></i
            >GROUP SHOWS:
          </div>
          <div class="collapsible-body">
            <ul class="list">
              <li>
                <span class="strong">“Annual Texas Artists Showcase”</span> (08/15/15),
                LuminArte Gallery, Dallas, TX
              </li>
              <li>
                <span class="strong">“Mnemosyne”</span> (02/21/15), LuminArte Gallery,
                Dallas, TX
              </li>
              <li>
                <span class="strong">“Frida”</span> (11/14), Hinovations Art Gallery,
                McAllen, TX
              </li>
              <li>
                <span class="strong"
                  >“Dallas, Fashion &amp; Art Show: Man as Machine”</span
                > (06/19/14), Three Three Three First Avenue, Dallas, TX
              </li>
              <li>
                <span class="strong">“Arte Latino”</span> (06-14-14), LuminArte Gallery,
                Dallas, TX
              </li>
              <li>
                <span class="strong">“ArtHash”</span> (12/13/13), White Space Gallery,
                Dallas, TX.
              </li>
              <li>
                <span class="strong">“A.D.D.”</span> (05/09/13), White Space Gallery,
                Dallas, TX.
              </li>
              <li>
                <span class="strong">“ArtHash's Kitsch and Flow”</span> (04/05/13),
                Fort Worth Community Arts Center, Fort Worth TX.
              </li>
              <li>
                <span class="strong"
                  >“Incrementum III - Alley's House 9th Annual Art Auction”</span
                > [Auction] (02/02/13), Gallery at Midtown, Dallas, TX.
              </li>
              <li>
                <span class="strong">“Underground '13 Sneak Peek”</span> (01/22/13),
                Janette Kennedy Gallery, Dallas, TX.
              </li>
              <li>
                <span class="strong">“TRANS- Membership Show 2012”</span> (08/04/12),
                MAC, Dallas, TX
              </li>
              <li>
                <span class="strong">“Artmoney - Thy 2012”</span> (June 30th, 2012),
                Limfjordscentret Doverodde Købmandsgård, Thy, Denmark.
              </li>
              <li>
                <span class="strong">“Do you hear the people sing?”</span> (March
                23th, 2012), American Airlines Center, Dallas, TX.
              </li>
              <li>
                <span class="strong">“125 PAA 7th Annual Juried Show”</span
                >[Juried] (March 8th, 2012), Plano Art Association/Colin
                College, Plano TX.
              </li>
              <li>
                <span class="strong"
                  >“Incrementum II - Alley's House 8th Annual Art Auction”</span
                > [Auction] (02-2012), Rising Gallery, Dallas, TX.
              </li>
              <li>
                <span class="strong">“Arthash”</span> (01-2012) Kettle Art Gallery,
                Dallas, TX.
              </li>
              <li>
                <span class="strong">“MOTA 8x8”</span> [Auction] (12-2011), Rising
                Gallery. Dallas, TX.
              </li>
              <li>
                <span class="strong">“Las Vegas Honors St Jude”</span> [Auction]
                (May 15, 2010) Four Seasons Hotel, Las Vegas, NV.
              </li>
              <li>
                <span class="strong"
                  >“Foundation for Recovery 2nd Annual Art of Recovery Exhibit
                  and Auction”</span
                > [Auction] (03/16/10), Foundation for Recovery, Las Vegas, NV.
              </li>
              <li>
                <span class="strong"
                  >“Foundation for Recovery 1st Annual Art of Recovery Exhibit
                  and Auction”</span
                > [Auction] (07/18/09), Foundation for Recovery, Las Vegas, NV.
              </li>
              <li>
                <span class="strong">“BIAM Artmoney Showroom”</span> (09/20/07 -
                09/20/08), BIAM, Copenhagen, Denmark.
              </li>
              <li>
                <span class="strong"
                  >“Forbidden Art, Finance of Expression”</span
                > (09/15/07), Pressen - Politikens Hus, Copenhagen, Denmark.
              </li>
              <li>
                <span class="strong">“Help Is On The Way XIII”</span> (08/05/07),
                Richmond / Ermet AIDS Foundation, San Francisco. CA.
              </li>
              <li>
                <span class="strong">“9th Annual Latino Art Auction 2007”</span>
                [Auction] (06/02/07), MACLA, San Jose, CA.
              </li>
              <li>
                <span class="strong">“First Friday”</span> (11/06 - ~/~), Mack Gallery,
                Las Vegas, NV.
              </li>
              <li>
                <span class="strong">“2nd Art and Wine Walk”</span> (06/03/09), The
                Stirling Club, Turnberry Place, Las Vegas, NV.
              </li>
              <li>
                <span class="strong">“Art and Wine Walk”</span> (06/11/08), The Stirling
                Club, Turnberry Place, Las Vegas, NV.
              </li>
              <li>
                <span class="strong">“Kraft Foods Special Event”</span> [Live Painting]
                (01/28/08) Tower Ballroom, Bellagio Hotel &amp; Casino, Las Vegas,
                NV.
              </li>
              <li>
                <span class="strong"
                  >“Help Is On The Way For The Holidays VIII”</span
                > [Auction] (2006), Richmond / Ermet AIDS Foundation, San Francisco.
                CA.
              </li>
              <li>
                <span class="strong">“Annual Silent Auction 2006”</span> [Auction]
                Oakland Fund for the Arts, Oakland, CA.
              </li>
              <li>
                <span class="strong">“Help Is On The Way XII”</span> [Auction] (2006),
                Richmond / Ermet AIDS Foundation, San Francisco. CA.
              </li>
              <li>
                <span class="strong">“8th Annual Latino Art Auction 2006”</span>
                [Auction] MACLA, San Jose, CA.
              </li>
              <li>
                <span class="strong">“First Friday”</span> (05/06 - 09/06), D' Mario
                Collection, Inc. Las Vegas, NV.
              </li>
              <li>
                <span class="strong">“Help Is On The Way XI”</span> [Auction] (2005),
                Richmond / Ermet AIDS Foundation, San Francisco. CA.
              </li>
              <li>
                <span class="strong">“7th Annual Latino Art Auction 2005”</span>
                [Auction] MACLA, San Jose, CA.
              </li>
              <li>
                <span class="strong">“De Corazon a Corazon”</span> (02/05), Casa
                de Ensueños Art Gallery / Hospital Civil. Guadalajara.
              </li>
              <li>
                <span class="strong">“Gran Subasta de Arte Actual”</span> [Auction]
                (12/04), Up &amp; Down. Guadalajara.
              </li>
              <li>
                <span class="strong">“Subasta de Arte, Primer Aniversario”</span
                > [Auction] (10/04), Casa de Ensueños Art Gallery, Guadalajara.
              </li>
              <li>
                <span class="strong">Auction / Collective Exhibition.</span> (2004),
                Contra Costa Symphony, Walnut Creek, CA.
              </li>
              <li>
                <span class="strong">“6th Annual Latino Art Auction 2004”</span>
                [Auction] MACLA, San Jose, CA.
              </li>
              <li>
                <span class="strong">“Annual Silent Auction 2004”</span> [Auction]
                Oakland Fund for the Arts, Oakland, CA.
              </li>
              <li>
                <span class="strong">“Exposición Permanente 2004”</span> Casa de
                Ensueños Art Gallery, Oakland, CA.
              </li>
              <li>
                <span class="strong">“Exposición Permanente 2004”</span> Casa de
                Ensueños Art Gallery, Guadalajara.
              </li>
              <li>
                <span class="strong">“Help Is On The Way X”</span> [Auction] (2004),
                Richmond / Ermet AIDS Foundation, San Francisco. CA.
              </li>
              <li>
                <span class="strong">“Subasta de Invierno”</span> [Auction] (12/03),
                CAF-ECO.
              </li>
              <li>
                <span class="strong">“Muerte - Arte”</span> (10/03), CAF-ECO. Guadalajara.
              </li>
              <li>
                <span class="strong"
                  >“Cultura en Espacios Abiertos de la Ciudad”</span
                > (10/03), Jardín del Carmen, (Secretaria de Cultura / H. Ayuntamiento
                de Guadalajara).
              </li>
              <li>
                <span class="strong"
                  >“Exposición de Pintura, Fotografía y Grabado”</span
                > (09/03), Galería 7, Universidad de Guadalajara.
              </li>
              <li>
                <span class="strong"
                  >“Salón 2003 de Jóvenes Promesas de la Plástica Jalisciense”
                  [Juried]</span
                >(09/03), Universidad de Guadalajara.
              </li>
              <li>
                <span class="strong"
                  >“XIII Salón de la Plástica Joven 2003”</span
                > (08/03), Centro de Arte Moderno de Guadalajara, A. C.
              </li>
              <li>
                <span class="strong">“Subasta de Verano”</span> [Auction] (07/03),
                CAF-ECO. Guadalajara.
              </li>
              <li>
                <span class="strong">“Semana Cultural de Letras”</span> Centro Universitario
                de Ciencias Sociales y Humanidades. Guadalajara.
              </li>
              <li>
                <span class="strong">“El Agora del Ex-convento del Carmen”</span
                > (03/03), Ex-convento del Carmen, Guadalajara.
              </li>
              <li>
                <span class="strong">“Semana Cultural en Psicología”</span> (03/03),
                Facultad de Psicología, Universidad de Guadalajara.
              </li>
              <li>
                <span class="strong"
                  >“Cultura en Espacios Públicos de la Ciudad”</span
                > (04/03), Jardín del Carmen, (Secretaria de Cultura / H. Ayuntamiento
                de Guadalajara).
              </li>
              <li>
                <span class="strong">“2do Expresarte”</span> (03/03), Escuela de
                Artes Plásticas, Universidad de Guadalajara.
              </li>
              <li>
                <span class="strong"
                  >“Poesía, Canto y Pintura a Guadalajara”</span
                > [Juried] (02/03). H. Ayuntamiento de Guadalajara.
              </li>
              <li>
                <span class="strong">“XI Salón del Pequeño Formato”</span> (12/02),
                Centro de Arte Moderno de Guadalajara, A.C.
              </li>
              <li>
                <span class="strong"
                  >“Salón 2002 de Jóvenes Promesas de la Plástica Jalisciense”</span
                > [Juried] (09/02), Universidad de Guadalajara.
              </li>
              <li>
                <span class="strong">“Concurso de Pintura”</span> [Juried] (07/02),
                Unión de Ajedrecistas de Guadalajara.
              </li>
              <li>
                <span class="strong">“Liberarte 2002”</span> [Juried] (06/02), Centro
                Cultural El Refugio, Tonala.
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</div>

<style>
  .list {
    margin-left: 40px;
  }
  .list li {
    list-style-type: disc !important;
  }
  .collapsible-header {
    background-color: #efebe9;
    font-size: 1.2em;
  }

  @media screen and (max-width: 800px) {
    .list {
      margin-left: 0px !important;
    }
  }
</style>
